module.exports = __webpack_public_path__ + "7ab06808e6562681cfb502b8e501e60b.png";